import React, { Component } from 'react'
import Avatar from 'shared-web/src/components/Avatar'

const TOTAL_AVATARS = 4

class MappedUsers extends Component {

  componentDidMount() {
    this.props.actions.fetchSFDCUserMappings()
  }

  render() {
    const userIds = this.props.sfdcUserMappings.map(user => user.userId)
    return (
      <div>
        {userIds.map((id, index)=> {
          if (index === this.props.max) return <span key={id}>+ {userIds.length - this.props.max} more</span>
          if (index > this.props.max) return null
          return <Avatar key={id} user={this.props.users[id]} />
        })}
      </div>
    )
  }
}

export default MappedUsers



// WEBPACK FOOTER //
// ./src/scripts/components/SFDC/MappedUsers.js